import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/feedback',
  component: Layout,
  name: 'FeedbackManagement',
  meta: { title: '意见反馈', icon: 'i-ep:chat-dot-round', menu: false },
  children: [
    {
      path: 'list',
      name: 'FeedbackList',
      component: () => import('@/views/feedback/index.vue'),
      meta: { title: '意见反馈', icon: 'i-ep:chat-dot-round' },
    },
    {
      path: 'detail/:id',
      name: 'FeedbackDetail',
      component: () => import('@/views/feedback/detail.vue'),
      meta: { title: '反馈详情', icon: 'i-ep:view', menu: false, activeMenu: '/feedback/list' },
    },
  ],
}

export default routes
